import { Ed25519KeyIdentity } from "@icp-sdk/core/identity"

const KEY = "phrug-story-identity"

// Each browser makes its own key and keeps it in localStorage, so the canister
// sees a distinct principal per browser and can rate-limit by it. Clearing site
// data makes a new one; the limit is a courtesy, not security.
export const loadIdentity = (storage = localStorage) => {
  const saved = storage.getItem(KEY)
  if (saved) {
    try { return Ed25519KeyIdentity.fromJSON(saved) } catch { /* fall through to a fresh key */ }
  }
  const identity = Ed25519KeyIdentity.generate()
  storage.setItem(KEY, JSON.stringify(identity.toJSON()))
  return identity
}
